import React, { Component } from 'react';
import { Example, Properties, SourceCode } from 'examples';
import Group from '../Group/Group';
import RadioButton from './RadioButton';

class RadioButtonExample extends Component {

  state = {
    checked: true,
    label: 'This is a radio button',
    selectedRadio: 'male',
  };

  onChange = e => this.setState(e.target.value);

  onDummyChange = () => window.showAppInfo(this.state.label);

  onChangeRadio = e => {
    window.showAppInfo(e.target.value);
    this.setState({ selectedRadio: e.target.value });
  };

  render() {
    const { selectedRadio, ...rest } = this.state;

    return (
      <Example {...this.props}>
        <Properties onChange={this.onChange} defaultProps={RadioButton.defaultProps} propTypes={RadioButton.propTypes} propValues={this.state}/>
        <Group>
          <RadioButton {...rest} onChange={this.onDummyChange}/>
          <div className="radio-button-group">
            <h3>Radiobutton group</h3>
            <RadioButton name="radio-group" label="Male" value="male" onChange={this.onChangeRadio} checked={selectedRadio === 'male'} />
            <RadioButton name="radio-group" label="Female" value="female" onChange={this.onChangeRadio} checked={selectedRadio === 'female'}/>
            <RadioButton name="radio-group" label="Transgender" value="transgender" onChange={this.onChangeRadio} checked={selectedRadio === 'transgender'}/>
          </div>
        </Group>
        <SourceCode querySelector=".radio-button-example .core-radiobutton"/>
      </Example>
    );
  }

}

RadioButtonExample.tags = 'toggle';

export default RadioButtonExample;
